module.exports = __webpack_public_path__ + "static/media/arrow-form.7ad303e3.svg";